/*
  Shopify Standard Actions, wired to this theme's cart.

  Shopify injects window.Shopify.actions, which the Shop app and AI agents
  use to open or change the cart. Configured here so that:

    openCart    opens our cart drawer instead of going to /cart
    updateCart  after Shopify has changed the cart, redraws the cart drawer
                and the cart page in place, without opening the drawer,
                and brings the Mix & Match lines in step

  Every other action keeps Shopify's own behaviour.
*/
(() => {
  // Redraws every cart on the page from the cart as it now is.
  async function refreshCarts() {
    const carts = Array.from(document.querySelectorAll('cart-drawer, cart-page'));
    const entries = carts.flatMap((cart) => cart.getSectionsToRender());
    if (!entries.length) return;

    const ids = [...new Set(entries.map((entry) => entry.id))].join(',');
    const response = await fetch(`${window.location.pathname}?sections=${ids}`, {
      headers: { Accept: 'application/json' },
    });
    const sections = await response.json();

    carts.forEach((cart) => cart.replaceSections({ sections }));
  }

  function init() {
    const actions = window.Shopify && window.Shopify.actions;
    if (!actions) return;

    actions.openCart.configure({
      async handler(defaultHandler) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.open();
          return;
        }
        return defaultHandler();
      },
    });

    actions.updateCart.configure({
      eventTarget: () => document,
      async handler(defaultHandler) {
        const result = await defaultHandler();
        try {
          await refreshCarts();
          if (window.MixMatch) window.MixMatch.refresh();
        } catch (error) {
          window.location.reload();
        }
        return result;
      },
    });
  }

  // The actions bundle may attach before or after this script runs.
  if (window.Shopify && window.Shopify.actions) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
